import { type KudoContentObjectDetail, createKudoContentObjectDetail } from 'models';
import { type UseQueryOptions, useQuery } from 'query';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services';
import { getKudo } from '../../services';
import { getContentObjectDetailQueryKey } from '../keys';

export const useKudoQuery = (
  id: string,
  queryOptions?: Omit<
    UseQueryOptions<KudoContentObjectDetail, ApiClientResponseError<ResponseErrorDataObject>>,
    'queryFn' | 'queryKey'
  >,
) =>
  useQuery<KudoContentObjectDetail>({
    async queryFn() {
      const { data } = await getKudo({ routeParams: { id } });
      return createKudoContentObjectDetail(data);
    },
    queryKey: getContentObjectDetailQueryKey({ id }),
    ...queryOptions,
  });
